/* src/app/modules/contact/contactbankaccounts/contactbankaccount.component.css */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.cba-page {
  min-width: 0;
  max-height: none;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}
.cba-header-text {
  min-width: 0;
  padding-right: 32px;
}
.cba-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.cba-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 36px 16px;
  text-align: center;
}
.cba-state > mat-icon {
  font-size: 44px;
  width: 44px;
  height: 44px;
  color: #d1d5db;
  margin-bottom: 6px;
}
.cba-state--error > mat-icon {
  color: #dc2626;
}
.cba-state__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #374151;
}
.cba-state__sub {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}
.cba-state .cf-btn {
  margin-top: 10px;
}
.cba-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.cba-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 8px 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  min-width: 0;
}
.cba-row--main {
  border-color: #c5d94a;
  background: #fbfee8;
}
.cba-row__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: #f4f6f8;
  flex-shrink: 0;
}
.cba-row__icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #6b7280;
}
.cba-row__info {
  flex: 1;
  min-width: 0;
}
.cba-row__iban {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Consolas,
    monospace;
  font-size: 13px;
  font-weight: 600;
  color: #1a1d23;
  overflow-wrap: anywhere;
}
.cba-row__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 10px;
  margin-top: 3px;
  font-size: 12px;
  color: #6b7280;
}
.cba-row__meta span {
  overflow-wrap: anywhere;
}
.cba-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 8px;
  border-radius: 20px;
  background: rgba(227, 253, 100, 0.45);
  color: #3f5a00;
  font-size: 11px;
  font-weight: 600;
}
.cba-badge mat-icon {
  font-size: 12px;
  width: 12px;
  height: 12px;
}
.cba-row__actions {
  display: flex;
  flex-shrink: 0;
}
.cba-row__btn {
  width: 34px !important;
  height: 34px !important;
  padding: 5px !important;
  color: #6b7280 !important;
}
.cba-row__btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.cba-row__btn--star {
  color: #7a9a00 !important;
}
.cba-row__btn--danger:hover {
  color: #dc2626 !important;
}
.cba-toggle {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
}
.cba-toggle__hint {
  font-size: 12px;
  color: #6b7280;
}
@media (max-width: 480px) {
  .cba-row {
    gap: 8px;
    padding: 8px 4px 8px 10px;
  }
  .cba-row__icon {
    display: none;
  }
  .cba-row__btn {
    width: 32px !important;
    height: 32px !important;
    padding: 4px !important;
  }
}
/*# sourceMappingURL=contactbankaccount.component.css.map */
